import React, { Component } from 'react';
import Icon from './Icon.js';
import './Svg.scss';
import './Icon.scss';

export default class ExpandIcon extends Component {
    render () {
        let finalClassName = Icon.buildCssClass(this.props);

        return (
            <svg className={finalClassName} width="24" height="24" viewBox="0 0 24 24">
                <path d="M10.008 1.423L.986 10.807a.548.548 0 0 1-.8 0 .602.602 0 0 1 0-.831L9.611.173a.548.548 0 0 1 .8 0l9.42 9.803a.599.599 0 0 1 .167.413c0 .148-.054.3-.167.413a.548.548 0 0 1-.8 0l-9.023-9.379z"/>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/icon/Collapse.js